import React from "react";
import "leaflet/dist/leaflet.css";
import './RoadAccidentDashboard.css';
import Mapfunction from "./Mapfunction/Mapfunction";
import Mapfun from "./Map";
import RAdatasection from "./Section1/RA_datasection";
import Overview from "../Overview/Overview";

const RoadAccidentDashboard = () => {
 
  return (
    <div>
      <Overview/>
      <RAdatasection/>
      <Mapfunction/>
      <Mapfun/>
    </div>
  );
};

export default RoadAccidentDashboard;